<div data-bs-spy="scroll" data-bs-target="#navbar-example2" data-bs-offset="10" tabindex="0">
    <!-- header -->
    <app-app-nav></app-app-nav>
    <!-- end header -->
    <main id="mainContent" tabindex="-1">

        <!-- HERO -->
        <section class="pb-0 position-relative">
            <div class="position-relative faculty-hero d-flex">
                <div class="slid-img position-absolute w-100 h-100 top-0 start-0 overflow-hidden">
                    <img class="position-absolute" src="{{faculty_image}}" alt="" />
                    <div class="black-layer position-absolute top-0 start-0 h-100 w-100"></div>
                </div>
                <div
                    class="position-relative d-flex align-items-lg-end justify-content-center institute-pref flex-column">
                    <div class="blend-darken-bg position-absolute top-0 start-0 h-100 w-100"></div>
                    <div
                        class="pref position-relative text-white pe-lg-5 pe-3 ms-3 animate__animated animate__slideInRight wow">
                        <span class="constr-type-badge" *ngIf="has(CONSTRUCTIONObj?.TYPE_TITLE)">
                            {{CONSTRUCTIONObj?.TYPE_TITLE}}
                        </span>
                        <h1 class="heading-font d-flex align-items-center gap-3 pt-3 mb-1">
                            <img class="constr-logo" *ngIf="has(CONSTRUCTIONObj?.CONSTRUCTION_LOGO)"
                                [src]="CONSTRUCTIONObj?.CONSTRUCTION_LOGO" alt="logo" />
                            <span>{{CONSTRUCTION_NAME}}</span>
                        </h1>
                        <span class="constr-name-eng" *ngIf="has(CONSTRUCTIONObj?.CONSTRUCTION_NAME_ENG)" dir="ltr">
                            {{CONSTRUCTIONObj?.CONSTRUCTION_NAME_ENG}}
                        </span>
                    </div>
                </div>
                <div class="position-absolute start-0 bottom-0 container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb animate__animated animate__fadeInDown">
                            <li class="breadcrumb-item">
                                <a class="text-white" routerLink="/">أكادميه الفنون</a>
                            </li>
                            <li class="breadcrumb-item">
                                <a class="text-white">إنشاءات الأكاديمية</a>
                            </li>
                            <li class="breadcrumb-item active text-white" aria-current="page">
                                {{CONSTRUCTION_NAME}}
                            </li>
                        </ol>
                    </nav>
                </div>
            </div>
        </section>

        <!-- SECTION NAV (tabs) -->
        <nav class="constr-nav" *ngIf="showView">
            <div class="container-fluid">
                <ul class="constr-nav-list list-unstyled mb-0">
                    <li><a (click)="scrollToSection('about', $event)"
                            [class.active]="activeSection === 'about'" role="button" tabindex="0" (keydown.enter)="scrollToSection('about', $event)" (keydown.space)="scrollToSection('about', $event)">نبذة</a></li>
                    <li *ngIf="has(CONSTRUCTIONObj?.ACT_PERSON_NAME)"><a (click)="scrollToSection('head', $event)"
                            [class.active]="activeSection === 'head'" role="button" tabindex="0" (keydown.enter)="scrollToSection('head', $event)" (keydown.space)="scrollToSection('head', $event)">كلمة المسؤول</a></li>
                    <li *ngIf="subdetailslist?.length"><a (click)="scrollToSection('sections', $event)"
                            [class.active]="activeSection === 'sections'" role="button" tabindex="0" (keydown.enter)="scrollToSection('sections', $event)" (keydown.space)="scrollToSection('sections', $event)">الأقسام</a></li>
                    <li *ngIf="galleryArry?.length"><a (click)="scrollToSection('gallery', $event)"
                            [class.active]="activeSection === 'gallery'" role="button" tabindex="0" (keydown.enter)="scrollToSection('gallery', $event)" (keydown.space)="scrollToSection('gallery', $event)">معرض الصور</a></li>
                    <li><a [routerLink]="['/constrction', id, 'news']">الأخبار</a></li>
                    <li><a [routerLink]="['/constrction', id, 'events']">الفعاليات</a></li>
                </ul>
            </div>
        </nav>

        <div class="container-fluid" *ngIf="showView">

            <!-- ABOUT -->
            <section id="about" class="constr-section">
                <div class="row">
                    <div class="col-xl-9 col-lg-11 mx-auto">
                        <div class="constr-heading">
                            <span class="constr-heading-accent"></span>
                            <h3 class="heading-font mb-0">
                                نبذة عن {{ aboutTitle() }}
                            </h3>
                        </div>
                        <p class="constr-about">{{CONSTRUCTION_ABOUT}}</p>
                        <p class="constr-about constr-about-eng" *ngIf="has(CONSTRUCTIONObj?.CONSTRUCTION_ABOUT_ENG)"
                            dir="ltr">{{CONSTRUCTIONObj?.CONSTRUCTION_ABOUT_ENG}}</p>

                        <div class="constr-social" *ngIf="hasSocial()">
                            <a *ngIf="has(CONSTRUCTIONObj?.CONSTRUCTION_FACEBOOK)"
                                [href]="CONSTRUCTIONObj?.CONSTRUCTION_FACEBOOK" target="_blank" rel="noopener"
                                aria-label="فيسبوك"><img src="assets/icon/facebook-app-symbol.png" alt="فيسبوك"></a>
                            <a *ngIf="has(CONSTRUCTIONObj?.CONSTRUCTION_INSTAGRAME)"
                                [href]="CONSTRUCTIONObj?.CONSTRUCTION_INSTAGRAME" target="_blank" rel="noopener"
                                aria-label="انستجرام"><img src="assets/icon/instagram.png" alt="إنستغرام"></a>
                            <a *ngIf="has(CONSTRUCTIONObj?.CONSTRUCTION_TWITTER)"
                                [href]="CONSTRUCTIONObj?.CONSTRUCTION_TWITTER" target="_blank" rel="noopener"
                                aria-label="تويتر"><img src="assets/icon/twitter.png" alt="تويتر"></a>
                            <a *ngIf="has(CONSTRUCTIONObj?.CONSTRUCTION_YOUTUBE)"
                                [href]="CONSTRUCTIONObj?.CONSTRUCTION_YOUTUBE" target="_blank" rel="noopener"
                                aria-label="يوتيوب"><img src="assets/icon/social.png" alt="يوتيوب"></a>
                            <a *ngIf="has(CONSTRUCTIONObj?.CONSTRUCTION_SITELINK)"
                                [href]="CONSTRUCTIONObj?.CONSTRUCTION_SITELINK" target="_blank" rel="noopener"
                                aria-label="الموقع"><img src="assets/icon/site.png" alt="الموقع الإلكتروني"></a>
                        </div>
                    </div>
                </div>
            </section>

            <!-- HEAD OF UNIT -->
            <section id="head" class="constr-section" *ngIf="has(CONSTRUCTIONObj?.ACT_PERSON_NAME)">
                <div class="row">
                    <div class="col-xl-9 col-lg-11 mx-auto">
                        <div class="constr-heading">
                            <span class="constr-heading-accent"></span>
                            <h3 class="heading-font mb-0">كلمة رئيس {{ aboutTitle() }}</h3>
                        </div>
                        <div class="head-card">
                            <img class="head-photo" *ngIf="has(CONSTRUCTIONObj?.ACT_PERSON_IMG)"
                                [src]="CONSTRUCTIONObj?.ACT_PERSON_IMG"
                                [alt]="CONSTRUCTIONObj?.ACT_PERSON_NAME" alt="">
                            <div class="head-avatar" *ngIf="!has(CONSTRUCTIONObj?.ACT_PERSON_IMG)">
                                {{personInitials()}}</div>
                            <div class="head-body">
                                <h4 class="head-name">{{CONSTRUCTIONObj?.ACT_PERSON_NAME}}</h4>
                                <span class="head-role" *ngIf="has(CONSTRUCTIONObj?.TYPE_TITLE)">
                                    مسؤول {{ aboutTitle() }}
                                </span>
                                <p class="head-word" *ngIf="has(CONSTRUCTIONObj?.ACT_PERSON_WORD)">
                                    <span class="quote-mark">“</span>{{CONSTRUCTIONObj?.ACT_PERSON_WORD}}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <!-- SECTIONS / HALLS -->
            <section id="sections" class="constr-section" *ngIf="subdetailslist?.length">
                <div class="constr-heading">
                    <span class="constr-heading-accent"></span>
                    <h3 class="heading-font mb-0">الأقسام والقاعات</h3>
                </div>
                <div class="row">
                    <div *ngFor="let item of subdetailslist"
                        class="col-lg-4 col-md-6 mb-4 animate__animated animate__fadeInUp animate__faster wow">
                        <div class="hall-card h-100">
                            <h5 class="hall-title">{{item.NAME}}</h5>
                            <p class="hall-desc" *ngIf="has(item.DESCRIPTION)">{{item.DESCRIPTION}}</p>
                            <ul class="hall-items list-unstyled mb-0" *ngIf="item.itemsList?.length">
                                <li *ngFor="let val of item.itemsList">{{val.NAME}}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>

            <!-- GALLERY -->
            <section id="gallery" class="constr-section" *ngIf="galleryArry?.length">
                <div class="constr-heading">
                    <span class="constr-heading-accent"></span>
                    <h3 class="heading-font mb-0">معرض الصور</h3>
                </div>
                <swiper [config]="galleryConfig" (click)="onGalleryClick($event)" class="swiper constrGallerySwiper">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide constr-gallery-slide" *ngFor="let item of galleryArry">
                            <div class="constr-gallery-item" data-bs-toggle="modal" data-bs-target="#imagePoup">
                                <img [src]="item.image_path" loading="lazy" alt="صورة من المنشأة">
                                <span class="constr-gallery-overlay"><i class="icon-search"></i></span>
                            </div>
                        </div>
                    </div>
                    <div class="swiper-pagination constr-gallery-pagination"></div>
                </swiper>
            </section>

        </div>

        <!-- Fallback -->
        <section *ngIf="!showView">
            <div class="row py-5">
                <div class="col-xl-8 col-lg-10 mx-auto">
                    <h3 class="text-center heading-font heading-style my-5 fw-normal">
                        صفحة تحت التطوير
                    </h3>
                </div>
            </div>
        </section>

    </main>
</div>

<div class="modal fade constr-image-modal" id="imagePoup" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-centered">
        <div class="modal-content">
            <button type="button" class="constr-image-close" data-bs-dismiss="modal" aria-label="إغلاق">
                <span aria-hidden="true">&times;</span>
            </button>
            <div class="modal-body p-0">
                <img class="w-100" [src]="src_image" alt="صورة من المنشأة">
            </div>
        </div>
    </div>
</div>
